<template>
    <div>
        <div
            id="content"
            class="content animated slideInRight delay-1s"
        >
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <CardHeader title=" Cadastrar Feriado"/>
                        <div class="card-body">
                            <div class="section-form">
                                <div class="row">
                                    <div class="col-md-12">
                                        <form id="form">
                                            <div class="row">
                                                <div class="col-md-4">
                                                    <div class="form-group">
                                                        <label for="description">
                                                            <span class="required">*</span>
                                                            Nome:
                                                        </label>
                                                        <input
                                                            type="text"
                                                            class='form-control'
                                                            v-model="holiday.name"
                                                        >
                                                    </div>
                                                </div>
                                                <div class="col-md-4">
                                                    <div class="form-group">
                                                        <label for="brand">
                                                            <span class="required">*</span>
                                                            Estado:
                                                        </label>
                                                        <input
                                                            type="text"
                                                            class='form-control'
                                                            v-model="holiday.state"
                                                        >
                                                    </div>
                                                </div>
                                                <div class="col-md-4">
                                                    <div class="form-group">
                                                        <label for="brand">
                                                            <span class="required">*</span>
                                                            Cidade:
                                                        </label>
                                                        <input
                                                            type="text"
                                                            class='form-control'
                                                            v-model="holiday.city"
                                                        >
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-4">
                                                    <div class="form-group">
                                                        <label for="description">
                                                            <span class="required">*</span>
                                                            Tipo de Feriado:
                                                        </label>
                                                        <v-select
                                                            :options="types"
                                                            label="name"
                                                            :reduce="types => types.name"
                                                            class="style-chooser"
                                                            v-model="holiday.type"
                                                        >
                                                            <div slot="no-options">Carregando...</div>
                                                        </v-select>
                                                    </div>
                                                </div>

                                                <div class="col-md-4">
                                                    <div class="form-group">
                                                        <label for="description">
                                                            <span class="required">*</span>
                                                            Dia ponte (Emenda de Feriado)?:
                                                        </label>
                                                        <v-select
                                                            :options="bridge_day"
                                                            label="name"
                                                            :reduce="bridge_day => bridge_day.name"
                                                            class="style-chooser"
                                                            v-model="holiday.bridge_day"
                                                        >
                                                            <div slot="no-options">Carregando...</div>
                                                        </v-select>
                                                    </div>
                                                </div>
                                                <div class="col-md-4">
                                                    <div class="form-group">
                                                        <label for="description">
                                                            <span class="required"></span>
                                                            Data:
                                                        </label>
                                                        <CtkDateTimePicker
                                                            v-model="holiday.date"
                                                            color="orange"
                                                            locale="pt-br"
                                                            no-label
                                                            only-date
                                                            format="YYYY-MM-DD HH:mm:ss"
                                                            button-now-translation="Hoje"
                                                            :minDate="now"
                                                            class="datetimepicker"
                                                            label="Selecione a data"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <hr>
                                            <div class="block text-right">
                                                <router-link
                                                    to="/holidays"
                                                    class="btn btn-back"
                                                >
                                                    <i class="fa fa-arrow-left mr-2"></i>
                                                    Voltar
                                                </router-link>
                                                <a
                                                    class="btn btn-add"
                                                    @click="save"
                                                >
                                                    Salvar
                                                    <i class="fa fa-save ml-2"></i>
                                                </a>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import vSelect from 'vue-select'
import CtkDateTimePicker from 'vue-ctk-date-time-picker';
import CardHeader from "../Base/CardHeader.vue";

export default {
    data() {
        return {
            holiday: {
                name: '',
                date: '',
                state: '',
                city: '',
                type: '',
                bridge_day: ''
            },
            cities: [],
            states: [],
            types: [
                {
                    id: 1,
                    name: 'Feriado Nacional'
                },
                {
                    id: 2,
                    name: 'Facultativo'
                },
                {
                    id: 3,
                    name: 'Dia Convencional'
                }
            ],
            bridge_day: [
                {
                    id: 1,
                    name: 'Sim'
                },
                {
                    id: 0,
                    name: 'Não'
                }
            ],
        }
    },
    computed: {
        filteredCities: function () {
            return this.cities.filter(x => x.state_id == this.branch.state);
        }
    },
    methods: {
        makeFormData: function () {
            const self = this;
            let fd = new FormData();

            fd.append('name', self.holiday.name);
            fd.append('date', self.holiday.date);
            fd.append('city', self.holiday.city);
            fd.append('state', self.holiday.state);
            fd.append('type', self.holiday.type);
            fd.append('bridge_day', self.holiday.bridge_day);

            if (self.holiday.id) {
                fd.append('id', self.holiday.id);
                fd.append('_method', 'PUT');
            }

            return fd;
        },
        save: function () {
            const self = this;
            let api = self.$store.state.api + 'holidays';

            let fd = self.makeFormData();

            if (self.holiday.id) {
                api += '/' + self.holiday.id;
            }

            self.$http.post(api, fd)
                .then((response) => {
                    self.$message('Sucesso', `Informações guardadas com sucesso`, 'success');
                    this.$router.push('/holidays');
                })
                .catch((error) => {
                    self.$message(null, error.response.data, 'error');
                });
        },
        getholidays: function (id) {
            const self = this;
            const api = self.$store.state.api + 'holidays/' + id;

            self.$http.get(api)
                .then((response) => {
                    self.holiday = response.data.data[0]
                })
                .catch((error) => {
                    self.$message(null, error.response.data, 'error');
                });
        },
        getStates: function (id) {
            const self = this;
            const api = self.$store.state.api + 'states?paginated=false';

            self.$http.get(api)
                .then((response) => {
                    self.states = response.data.data
                })
                .catch((error) => {
                    self.$message(null, error.response.data, 'error');
                });
        },
        getCities: function (id) {
            const self = this;
            const api = self.$store.state.api + 'cities?paginated=false';

            self.$http.get(api)
                .then((response) => {
                    self.cities = response.data.data
                })
                .catch((error) => {
                    self.$message(null, error.response.data, 'error');
                });
        },
    },
    mounted: function () {
        const self = this;
        let id = self.$route.params.id;
        self.getStates();
        self.getCities();
        if (id) {
            self.getholidays(id);
        }
    },
    components: {
        CardHeader,
        vSelect, CtkDateTimePicker
    },
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Holidays/Add.vue